import React from "react";
import ServiceListSection from "./ServiceListSection";

const Services = ({ serviceListData }) => (
  <ServiceListSection title="Services" serviceListData={serviceListData} />
);

export default Services;
